var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateNewNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.99799H8.5V12.998C8.5 13.2632 8.39464 13.5176 8.20711 13.7051C8.01957 13.8926 7.76522 13.998 7.5 13.998C7.23478 13.998 6.98043 13.8926 6.79289 13.7051C6.60536 13.5176 6.5 13.2632 6.5 12.998V7.99799H1.5C1.23478 7.99799 0.98043 7.89263 0.792893 7.70509C0.605357 7.51756 0.5 7.2632 0.5 6.99799C0.5 6.73277 0.605357 6.47842 0.792893 6.29088C0.98043 6.10334 1.23478 5.99799 1.5 5.99799H6.5V0.997986C6.5 0.732769 6.60536 0.478415 6.79289 0.290879C6.98043 0.103342 7.23478 -0.00201416 7.5 -0.00201416C7.76522 -0.00201416 8.01957 0.103342 8.20711 0.290879C8.39464 0.478415 8.5 0.732769 8.5 0.997986V5.99799H13.5C13.7652 5.99799 14.0196 6.10334 14.2071 6.29088C14.3946 6.47842 14.5 6.73277 14.5 6.99799C14.5 7.2632 14.3946 7.51756 14.2071 7.70509C14.0196 7.89263 13.7652 7.99799 13.5 7.99799Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewNode);
export default __webpack_public_path__ + "static/media/create-new-node.cccf7587efebc6cde8f7079330a48583.svg";
export { ForwardRef as ReactComponent };